import { useState, useCallback, useEffect, useContext } from "react";
import { listAppointments } from "../../../services/appointments.api";
import { SocketContext } from "../../../context/Socket/SocketContext";
import { AuthContext } from "../../../context/Auth/AuthContext";
import toastError from "../../../errors/toastError";

export function useAppointments(params = {}) {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const socketManager = useContext(SocketContext);

  const fetchAppointments = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await listAppointments(params);
      setAppointments(data.appointments || []);
    } catch (e) {
      toastError(e);
    } finally {
      setLoading(false);
    }
  }, [params.dateFrom, params.dateTo, params.professionalId, params.status]);

  useEffect(() => { fetchAppointments(); }, [fetchAppointments]);

  useEffect(() => {
    const socket = socketManager?.getSocket?.(user?.companyId);
    if (!socket) return;
    socket.on("appointment:created", () => fetchAppointments());
    socket.on("appointment:updated", () => fetchAppointments());
    return () => {
      socket.off("appointment:created");
      socket.off("appointment:updated");
    };
  }, [socketManager, user?.companyId, fetchAppointments]);

  return { appointments, loading, fetchAppointments };
}
